module.exports = __webpack_public_path__ + "img/travelResources.ba7a9f42.png";